export default __webpack_public_path__ + "static/media/TrackLiveOrders.e6d4f940.svg";